import axios from '../axiosInstance';
import { getApiBaseUrl, getForwardedHost } from './apiClient';
import type { PrometheusRangeResponse, PrometheusInstantResponse } from '../../containers/pages/CANsense/DashboardV2/types';

const getApiUrl = (endpoint: string): string => {
  return `${getApiBaseUrl()}/sense/prometheus${endpoint}`;
};

export async function queryRange(
  query: string,
  start: number,
  end: number,
  step: string,
): Promise<PrometheusRangeResponse> {
  const API_URL = getApiUrl('/query_range');
  const response = await axios.get(API_URL, {
    params: { query, start, end, step },
    headers: {
      'X-Forwarded-Host': getForwardedHost(API_URL),
    },
  });
  return response.data?.data || response.data;
}

export async function queryInstant(
  query: string,
): Promise<PrometheusInstantResponse> {
  const API_URL = getApiUrl('/query');
  const response = await axios.get(API_URL, {
    params: { query },
    headers: {
      'X-Forwarded-Host': getForwardedHost(API_URL),
    },
  });
  return response.data?.data || response.data;
}
